import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { OrganizationService } from '@aid/core/services/organization.service';
import { UserService } from '@aid/core/services/user.service';
import { UserPermission } from '@aid/core/types/enums';

@Injectable()
export class CommissionAdminGuard {
  private readonly userService = inject(UserService);

  constructor(
    private router: Router,
    private organizationService: OrganizationService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const canManageAccounting = this.userService.hasPermission([
      UserPermission.CAN_MANAGE_ACCOUNTING
    ]);
    if (!canManageAccounting) {
      this.router.navigate([
        this.organizationService.requireOrganization().slug
      ]);
    }
    return canManageAccounting;
  }
}
